import { FC } from "react"
import classNames from "classnames"

import * as styles from "./Pill.module.scss"

export interface Props
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  children: React.ReactNode
  className?: string
}

export const Pill: FC<Props> = ({ className, children, ...otherBtnProps }) => {
  return (
    <button
      {...otherBtnProps}
      className={classNames(styles.pillContainer, className)}
    >
      {children}
    </button>
  )
}
